import LabelAnnotationLocation from './LabelAnnotationLocation';
import LabelAnnotationTextBuilder from '../lib/builders/LabelAnnotationTextBuilder';
import { gConsts } from '@/globals/gConsts';

/**
 * Anotação de label.
 */
export default class LabelAnnotation {

    /**
     * @param {string} tipo Tipo da anotação.
     * @param {string} toolId Id referente a marcação (ferramenta/tool).
     * @param {LabelAnnotationLocation} localizacao
     * @param {{label: string, type: string, format: string, text: string}[]} qualificadores
     */
    constructor(tipo, toolId, localizacao = new LabelAnnotationLocation(), qualificadores = []) {
        /** Tipo da anotação.
         * @type {string}
        */
        this.tipo = tipo;
        /** Referencia primaria é o id da ferramenta/tool. */
        this.id = toolId;
        /** Id referente a marcação (ferramenta/tool).
         * @type {string}
        */
        this.toolId = toolId;
        /** Texto da anotação no relatório.
         * @type {string} */
        this.reportText = '';
        /** Localização da anotação.
         * @type {LabelAnnotationLocation}
        */
        this.localizacao = localizacao;

        /** @type {{label: string, type: string, format: string, text: string}[]}
         * 
         * @example
         * [
         *  {label: 'material aquém', type: 'materialAquem', format: 'NEW_LINE', text: 'Material obturador aquém do forame apical no(s) dente(s):'},
         *  {label: 'material além', type: 'materialAlem', format: 'NEW_LINE', text: 'Material obturador além do forame apical no(s) dente(s):'}
         * ]
        */
        this.qualificadores = qualificadores || [];

        /** Cor principal da anotação.
         * @type {string}
        */
        this.color = this.getColor();

        /** Indica se a anotação foi editada manualmente (pelo popup de anotação).
         * 
         * Caso seja true, o refresh da localizacao não é aplicado automaticamente.
         * @type {boolean}
        */
        this.edited = false;

        this.refreshReportText();
    }

    /**
     * @param {Object} object
     * @returns {LabelAnnotation}
     */
    static fromObject(object) {
        let labelAnnotation = new LabelAnnotation(object.tipo, object.toolId, LabelAnnotationLocation.fromObject(object.localizacao), object.qualificadores);
        labelAnnotation.reportText = object.reportText;
        labelAnnotation.edited = object.edited;
        labelAnnotation.color = object.color;
        return labelAnnotation;
    }

    toObject() {
        return JSON.parse(JSON.stringify(this));
    }

    setToolId(toolId) {
        this.toolId = toolId;
        this.id = toolId;
    }

    getColor() {
        let color = null;
        if (this.localizacao.dentes.length > 0) {
            if (this.localizacao.dentes.length == 1) {
                color = this.localizacao.dentes[0].color;
            }
        } else if (this.localizacao.regioesAnatomicas.length > 0) {
            if (this.localizacao.regioesAnatomicas.length == 1) {
                color = this.localizacao.regioesAnatomicas[0].color;
            }
        }

        return color || gConsts.node.report.annotation.colors.DEFAULT;
    }

    /**
     * Atualiza a anotação com os novos valores.
     * @param {LabelAnnotationLocation} localizacao
     * @param {{label: string, type: string, format: string, text: string}[]} qualificadores
     */
    update(localizacao, qualificadores) {
        this.localizacao = localizacao;
        this.qualificadores = qualificadores;
        this.edited = true;
        this.refreshReportText();
        this.color = this.getColor();
    }

    refreshReportText() {
        this.reportText = new LabelAnnotationTextBuilder(this)
            .build();
    }
}